export default "__VITE_ASSET__e16895a2__"